const globals = {
    "app-application-name": "Application.name",
    "app-application-hiv-name": "Application.hiv_name",
    "app-id-applicazione": "",
    "app-nome-dominio": process.env.REACT_APP_APP_NOME_DOMINIO,
    "app-url-backend": process.env.REACT_APP_APP_URL_BACKEND,
    "app-url-backend-toponomastica": process.env.REACT_APP_APP_URL_BACKEND_TOPONOMASTICA,
    "app-url-backend-malattie": process.env.REACT_APP_APP_URL_BACKEND_MALATTIE,
    "app-url-backend-focolai": process.env.REACT_APP_APP_URL_BACKEND_FOCOLAI,
    "app-url-backend-segnalazioni": process.env.REACT_APP_APP_URL_BACKEND_SEGNALAZIONI,
    "app-url-backend-anagrafica": process.env.REACT_APP_APP_URL_BACKEND_ANAGRAFICA,
    "app-url-backend-strutture": process.env.REACT_APP_APP_URL_BACKEND_STRUTTURE,
    "app-url-backend-premal": process.env.REACT_APP_APP_URL_BACKEND_PREMAL,
    "app-url-backend-siavr": process.env.REACT_APP_APP_URL_BACKEND_SIAVR,
    "app-url-backend-segnalazioni-hiv": process.env.REACT_APP_APP_URL_BACKEND_SEGNALAZIONI_HIV,
    "errori-espliciti": process.env.REACT_APP_ERRORI_ESPLICITI,
    "app-application-logo": "img/avatar/avatar_padre.png",
    "app-application-logo-woman": "img/avatar/avatar_madre.png",
    "app-application-logo-man": "img/avatar/avatar_padre.png",
    "app-application-logo-alt": "img/avatar/avatar_madre.png",
    "app-application-campana": "img/icons/campana.svg",
    "app-application-campana-notifiche": "img/icons/campana-notifiche.svg",
    "app-header-image": require("../img/logo/logo-regione-veneto--bw.png"),
    "app-icon-sprite": "svg/sprite.svg",
    appWidthBreakdown: 1220,
    "lingua-default": "it-IT",
    lingua_default: "it",
    "dimesione-massima-file": process.env.REACT_APP_DIMENSIONE_MASSIMA_FILE,
    "malattie-contact-tracing": process.env.REACT_APP_MALATTIE_CONTACT_TRACING,
    "malattie-caricamento-pdf-step-3": process.env.REACT_APP_MALATTIE_CARICAMENTO_PDF_STEP_3,
    "attivazione-sorveglianza-hiv": process.env.REACT_APP_ATTIVAZIONE_SORVEGLIANZA_HIV,
    "data-inizio-monkeypox":process.env.REACT_APP_DATA_INIZIO_MONKEYPOX,
    "notifiche-sirmi-lis": process.env.REACT_APP_NOTIFICHE_SIRMI_LIS,
};

export default globals;
